import { StyledSectionTitle, StyledSeparatorLine } from "./index.styled";
import downloadIcon from "../../../assets/icons/download.webp";

interface SectionTitleProps {
  title: string;
  titleStyle?: React.CSSProperties;
  hasDownload?: boolean;
  onDownload?: () => void;
}

const SectionTitle = ({
  title,
  titleStyle = {},
  hasDownload = false,
  onDownload,
}: SectionTitleProps) => {
  return (
    <StyledSectionTitle>
      <h2 style={titleStyle}>{title}</h2>
      <StyledSeparatorLine />
      {hasDownload && (
        <div className="download-button-container">
          <div className="download-button" onClick={onDownload}>
            <img src={downloadIcon} alt="download" />
          </div>
        </div>
      )}
    </StyledSectionTitle>
  );
};

export default SectionTitle;
